// You can write more code here

/* START OF COMPILED CODE */

import DefaultConfirmButton_m from '../DefaultConfirmButton_m';
import DefaultButton from '../GeneralUI/Buttons/DefaultButton';
import UIBlocker from '../GeneralUI/UIBlocker';
import Cursor from '../StudentGame/Cursor';
import HeartContainer from './HeartContainer';
/* START-USER-IMPORTS */
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import {
  getAnchorPlugin,
  waitForMilliseconds,
  waitForSeconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { WalkthroughController } from '@/game/GameComponents/PhaserGame/Utils/WalkthroughController';
/* END-USER-IMPORTS */

export default class DuelWalkthroughPanel extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker);

    // greenleafMobile
    const greenleafMobile = scene.add.container(147, 382);
    this.add(greenleafMobile);

    // greenleaf_m
    const greenleaf_m = scene.add.image(0, 0, 'npc_mentor_e_portrait');
    greenleaf_m.scaleX = -0.4;
    greenleaf_m.scaleY = 0.4;
    greenleafMobile.add(greenleaf_m);

    // greenleafDesktop
    const greenleafDesktop = scene.add.container(870, 538);
    this.add(greenleafDesktop);

    // greenleaf
    const greenleaf = scene.add.image(0, 0, 'npc_mentor_e_portrait');
    greenleaf.scaleX = 0.4;
    greenleaf.scaleY = 0.4;
    greenleafDesktop.add(greenleaf);

    // healthBarRightOverlay
    const healthBarRightOverlay = scene.add.container(1024, 0);
    this.add(healthBarRightOverlay);

    // walkthroughPanel_6
    const walkthroughPanel_6 = scene.add.container(0, 0);
    healthBarRightOverlay.add(walkthroughPanel_6);

    // walkthrough6_mainContainer
    const walkthrough6_mainContainer = scene.add.container(0, 0);
    walkthroughPanel_6.add(walkthrough6_mainContainer);

    // labelContainer_6
    const labelContainer_6 = scene.add.container(-496, 134);
    walkthrough6_mainContainer.add(labelContainer_6);

    // textBacking_6
    const textBacking_6 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      76,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_6.scaleX = 4;
    textBacking_6.scaleY = 32;
    textBacking_6.setOrigin(0.5, 0);
    textBacking_6.alpha = 0.5;
    textBacking_6.tint = 3023407;
    labelContainer_6.add(textBacking_6);

    // walkthroughLabel_6
    const walkthroughLabel_6 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Opponent Hit Points',
    );
    walkthroughLabel_6.setOrigin(0.5, 0);
    walkthroughLabel_6.tintTopLeft = 15130076;
    walkthroughLabel_6.tintTopRight = 15130076;
    walkthroughLabel_6.tintBottomLeft = 15130076;
    walkthroughLabel_6.tintBottomRight = 15130076;
    walkthroughLabel_6.text = 'Opponent Hit Points';
    walkthroughLabel_6.fontSize = -28;
    labelContainer_6.add(walkthroughLabel_6);

    // guidanceArrow_4
    const guidanceArrow_4 = scene.add.image(-320, 152, 'GuidanceArrow-Small');
    guidanceArrow_4.scaleX = 4;
    guidanceArrow_4.scaleY = 4;
    guidanceArrow_4.angle = -90;
    guidanceArrow_4.flipY = true;
    walkthrough6_mainContainer.add(guidanceArrow_4);

    // duelistHealthBar
    const duelistHealthBar = scene.add.nineslice(
      -16,
      120,
      'Hud2',
      undefined,
      64,
      16,
      4,
      4,
      4,
      4,
    );
    duelistHealthBar.scaleX = 4;
    duelistHealthBar.scaleY = 4;
    duelistHealthBar.setOrigin(1, 0);
    walkthrough6_mainContainer.add(duelistHealthBar);

    // heartContainer_5
    const heartContainer_5 = new HeartContainer(scene, -60, 152);
    walkthrough6_mainContainer.add(heartContainer_5);

    // heartContainer_6
    const heartContainer_6 = new HeartContainer(scene, -96, 152);
    walkthrough6_mainContainer.add(heartContainer_6);

    // heartContainer_7
    const heartContainer_7 = new HeartContainer(scene, -132, 152);
    walkthrough6_mainContainer.add(heartContainer_7);

    // healthBarLeftOverlay
    const healthBarLeftOverlay = scene.add.container(0, 0);
    this.add(healthBarLeftOverlay);

    // walkthroughPanel_5
    const walkthroughPanel_5 = scene.add.container(0, 0);
    healthBarLeftOverlay.add(walkthroughPanel_5);

    // walkthrough5_mainContainer
    const walkthrough5_mainContainer = scene.add.container(16, 120);
    walkthroughPanel_5.add(walkthrough5_mainContainer);

    // labelContainer_5
    const labelContainer_5 = scene.add.container(448, 14);
    walkthrough5_mainContainer.add(labelContainer_5);

    // textBacking_5
    const textBacking_5 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      64,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_5.scaleX = 4;
    textBacking_5.scaleY = 32;
    textBacking_5.setOrigin(0.5, 0);
    textBacking_5.alpha = 0.5;
    textBacking_5.tint = 3023407;
    labelContainer_5.add(textBacking_5);

    // walkthroughLabel_5
    const walkthroughLabel_5 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Player Hit Points',
    );
    walkthroughLabel_5.setOrigin(0.5, 0);
    walkthroughLabel_5.tintTopLeft = 15130076;
    walkthroughLabel_5.tintTopRight = 15130076;
    walkthroughLabel_5.tintBottomLeft = 15130076;
    walkthroughLabel_5.tintBottomRight = 15130076;
    walkthroughLabel_5.text = 'Player Hit Points';
    walkthroughLabel_5.fontSize = -28;
    labelContainer_5.add(walkthroughLabel_5);

    // guidanceArrow_3
    const guidanceArrow_3 = scene.add.image(300, 32, 'GuidanceArrow-Small');
    guidanceArrow_3.scaleX = 4;
    guidanceArrow_3.scaleY = 4;
    guidanceArrow_3.angle = -90;
    walkthrough5_mainContainer.add(guidanceArrow_3);

    // duelistHealthBar_1
    const duelistHealthBar_1 = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      64,
      16,
      4,
      4,
      4,
      4,
    );
    duelistHealthBar_1.scaleX = 4;
    duelistHealthBar_1.scaleY = 4;
    duelistHealthBar_1.setOrigin(0, 0);
    walkthrough5_mainContainer.add(duelistHealthBar_1);

    // heartContainer
    const heartContainer = new HeartContainer(scene, 44, 32);
    walkthrough5_mainContainer.add(heartContainer);

    // heartContainer_1
    const heartContainer_1 = new HeartContainer(scene, 80, 32);
    walkthrough5_mainContainer.add(heartContainer_1);

    // heartContainer_2
    const heartContainer_2 = new HeartContainer(scene, 116, 32);
    walkthrough5_mainContainer.add(heartContainer_2);

    // heartContainer_3
    const heartContainer_3 = new HeartContainer(scene, 152, 32);
    walkthrough5_mainContainer.add(heartContainer_3);

    // heartContainer_4
    const heartContainer_4 = new HeartContainer(scene, 188, 32);
    walkthrough5_mainContainer.add(heartContainer_4);

    // topRightOverlay
    const topRightOverlay = scene.add.container(1024, 0);
    this.add(topRightOverlay);

    // walkthroughPanel_11
    const walkthroughPanel_11 = scene.add.container(0, 0);
    walkthroughPanel_11.visible = false;
    topRightOverlay.add(walkthroughPanel_11);

    // guidanceArrow_5
    const guidanceArrow_5 = scene.add.image(-80, 136, 'GuidanceArrow-Small');
    guidanceArrow_5.scaleX = 4;
    guidanceArrow_5.scaleY = 4;
    walkthroughPanel_11.add(guidanceArrow_5);

    // exitReveal
    const exitReveal = scene.add.image(-80, 64, 'exit1-reveal_32');
    exitReveal.scaleX = 2;
    exitReveal.scaleY = 2;
    walkthroughPanel_11.add(exitReveal);

    // labelContainer_11
    const labelContainer_11 = scene.add.container(-72, 164);
    walkthroughPanel_11.add(labelContainer_11);

    // textBacking_11
    const textBacking_11 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      40,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_11.scaleX = 4;
    textBacking_11.scaleY = 32;
    textBacking_11.setOrigin(0.5, 0);
    textBacking_11.alpha = 0.5;
    textBacking_11.tint = 3023407;
    labelContainer_11.add(textBacking_11);

    // walkthroughLabel_11
    const walkthroughLabel_11 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Quit Duel',
    );
    walkthroughLabel_11.setOrigin(0.5, 0);
    walkthroughLabel_11.tintTopLeft = 15130076;
    walkthroughLabel_11.tintTopRight = 15130076;
    walkthroughLabel_11.tintBottomLeft = 15130076;
    walkthroughLabel_11.tintBottomRight = 15130076;
    walkthroughLabel_11.text = 'Quit Duel';
    walkthroughLabel_11.fontSize = -28;
    labelContainer_11.add(walkthroughLabel_11);

    // walkthroughPanel_10
    const walkthroughPanel_10 = scene.add.container(0, 0);
    topRightOverlay.add(walkthroughPanel_10);

    // guidanceArrow_2
    const guidanceArrow_2 = scene.add.image(-152, 132, 'GuidanceArrow-Small');
    guidanceArrow_2.scaleX = 4;
    guidanceArrow_2.scaleY = 4;
    walkthroughPanel_10.add(guidanceArrow_2);

    // exitReveal_1
    const exitReveal_1 = scene.add.image(-152, 64, 'settings-reveal');
    exitReveal_1.scaleX = 4;
    exitReveal_1.scaleY = 4;
    walkthroughPanel_10.add(exitReveal_1);

    // labelContainer_10
    const labelContainer_10 = scene.add.container(-152, 160);
    walkthroughPanel_10.add(labelContainer_10);

    // textBacking_10
    const textBacking_10 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      32,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_10.scaleX = 4;
    textBacking_10.scaleY = 32;
    textBacking_10.setOrigin(0.5, 0);
    textBacking_10.alpha = 0.5;
    textBacking_10.tint = 3023407;
    labelContainer_10.add(textBacking_10);

    // walkthroughLabel_10
    const walkthroughLabel_10 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Settings',
    );
    walkthroughLabel_10.setOrigin(0.5, 0);
    walkthroughLabel_10.tintTopLeft = 15130076;
    walkthroughLabel_10.tintTopRight = 15130076;
    walkthroughLabel_10.tintBottomLeft = 15130076;
    walkthroughLabel_10.tintBottomRight = 15130076;
    walkthroughLabel_10.text = 'Settings';
    walkthroughLabel_10.fontSize = -28;
    labelContainer_10.add(walkthroughLabel_10);

    // topCenterOverlay
    const topCenterOverlay = scene.add.container(512, 0);
    this.add(topCenterOverlay);

    // walkthroughPanel_7
    const walkthroughPanel_7 = scene.add.container(0, 0);
    topCenterOverlay.add(walkthroughPanel_7);

    // labelContainer_7
    const labelContainer_7 = scene.add.container(0, 156);
    walkthroughPanel_7.add(labelContainer_7);

    // textBacking_7
    const textBacking_7 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      52,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_7.scaleX = 4;
    textBacking_7.scaleY = 32;
    textBacking_7.setOrigin(0.5, 0);
    textBacking_7.alpha = 0.5;
    textBacking_7.tint = 3023407;
    labelContainer_7.add(textBacking_7);

    // walkthroughLabel_7
    const walkthroughLabel_7 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Select Spell',
    );
    walkthroughLabel_7.setOrigin(0.5, 0);
    walkthroughLabel_7.tintTopLeft = 15130076;
    walkthroughLabel_7.tintTopRight = 15130076;
    walkthroughLabel_7.tintBottomLeft = 15130076;
    walkthroughLabel_7.tintBottomRight = 15130076;
    walkthroughLabel_7.text = 'Select Spell';
    walkthroughLabel_7.fontSize = -28;
    labelContainer_7.add(walkthroughLabel_7);

    // guidanceArrow_6
    const guidanceArrow_6 = scene.add.image(0, 132, 'GuidanceArrow-Small');
    guidanceArrow_6.scaleX = 4;
    guidanceArrow_6.scaleY = 4;
    guidanceArrow_6.flipX = true;
    walkthroughPanel_7.add(guidanceArrow_6);

    // ripostesOverlay
    const ripostesOverlay = scene.add.container(512, 384);
    this.add(ripostesOverlay);

    // walkthroughPanel_8
    const walkthroughPanel_8 = scene.add.container(0, 0);
    ripostesOverlay.add(walkthroughPanel_8);

    // backing_1
    const backing_1 = scene.add.image(0, 0, '1x1sprite');
    backing_1.scaleX = 3200;
    backing_1.scaleY = 2048;
    backing_1.alpha = 0.5;
    backing_1.alphaTopLeft = 0.5;
    backing_1.alphaTopRight = 0.5;
    backing_1.alphaBottomLeft = 0.5;
    backing_1.alphaBottomRight = 0.5;
    backing_1.tintTopLeft = 0;
    backing_1.tintTopRight = 0;
    backing_1.tintBottomLeft = 0;
    backing_1.tintBottomRight = 0;
    walkthroughPanel_8.add(backing_1);

    // modalContainer
    const modalContainer = scene.add.container(0, 0);
    walkthroughPanel_8.add(modalContainer);

    // nineslice
    const nineslice = scene.add.nineslice(
      0,
      204,
      'Hud3',
      undefined,
      92,
      36,
      16,
      16,
      16,
      16,
    );
    nineslice.scaleX = 4;
    nineslice.scaleY = 4;
    modalContainer.add(nineslice);

    // riposteTypingView
    const riposteTypingView = scene.add.container(0, -56);
    modalContainer.add(riposteTypingView);

    // typingBacking
    const typingBacking = scene.add.image(7, 82, 'Card-512');
    typingBacking.scaleX = 2;
    typingBacking.scaleY = 2;
    riposteTypingView.add(typingBacking);

    // bitmaptext_1
    const bitmaptext_1 = scene.add.bitmapText(0, 82, 'Aronui', 'Tap');
    bitmaptext_1.setOrigin(0.5, 0.5);
    bitmaptext_1.tintTopLeft = 6896829;
    bitmaptext_1.tintTopRight = 6896829;
    bitmaptext_1.tintBottomLeft = 6896829;
    bitmaptext_1.tintBottomRight = 6896829;
    bitmaptext_1.text = 'Tap';
    bitmaptext_1.fontSize = -64;
    riposteTypingView.add(bitmaptext_1);

    // cursor
    const cursor = new Cursor(scene, 66, 82);
    riposteTypingView.add(cursor);

    // buttons
    const buttons = scene.add.container(0, 232);
    buttons.scaleX = 2;
    buttons.scaleY = 2;
    modalContainer.add(buttons);

    // image_1
    const image_1 = scene.add.image(0, 0, 'ui-definition-button');
    image_1.scaleX = 2;
    image_1.scaleY = 2;
    buttons.add(image_1);

    // image
    const image = scene.add.image(-36, 0, 'ui-repeat-button');
    image.scaleX = 2;
    image.scaleY = 2;
    buttons.add(image);

    // image_2
    const image_2 = scene.add.image(36, 0, 'ui-speak-button');
    image_2.scaleX = 2;
    image_2.scaleY = 2;
    buttons.add(image_2);

    // riposteHeader
    const riposteHeader = scene.add.container(0, -280);
    modalContainer.add(riposteHeader);

    // riposteHeaderBacking
    const riposteHeaderBacking = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      100,
      16,
      8,
      8,
      8,
      8,
    );
    riposteHeaderBacking.scaleX = 4;
    riposteHeaderBacking.scaleY = 4;
    riposteHeader.add(riposteHeaderBacking);

    // riposteHeaderText
    const riposteHeaderText = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Perform Counter',
    );
    riposteHeaderText.setOrigin(0.5, 0.5);
    riposteHeaderText.tintTopLeft = 985612;
    riposteHeaderText.tintTopRight = 985612;
    riposteHeaderText.tintBottomLeft = 985612;
    riposteHeaderText.tintBottomRight = 985612;
    riposteHeaderText.text = 'Perform Counter';
    riposteHeaderText.fontSize = -24;
    riposteHeader.add(riposteHeaderText);

    // buttonBacking_2
    const buttonBacking_2 = scene.add.image(0, 168, 'default-button-confirm');
    buttonBacking_2.scaleX = 2;
    buttonBacking_2.scaleY = 2;
    modalContainer.add(buttonBacking_2);

    // buttonLabel_2
    const buttonLabel_2 = scene.add.bitmapText(0, 168, 'Aronui', 'Submit');
    buttonLabel_2.setOrigin(0.5, 0.5);
    buttonLabel_2.tintTopLeft = 15130076;
    buttonLabel_2.tintTopRight = 15130076;
    buttonLabel_2.tintBottomLeft = 15130076;
    buttonLabel_2.tintBottomRight = 15130076;
    buttonLabel_2.text = 'Submit';
    buttonLabel_2.fontSize = -14;
    modalContainer.add(buttonLabel_2);

    // walkthroughPanel_9
    const walkthroughPanel_9 = scene.add.container(0, 0);
    walkthroughPanel_9.visible = false;
    ripostesOverlay.add(walkthroughPanel_9);

    // backing
    const backing = scene.add.image(0, 0, '1x1sprite');
    backing.scaleX = 3200;
    backing.scaleY = 2048;
    backing.alpha = 0.5;
    backing.alphaTopLeft = 0.5;
    backing.alphaTopRight = 0.5;
    backing.alphaBottomLeft = 0.5;
    backing.alphaBottomRight = 0.5;
    backing.tintTopLeft = 0;
    backing.tintTopRight = 0;
    backing.tintBottomLeft = 0;
    backing.tintBottomRight = 0;
    walkthroughPanel_9.add(backing);

    // modalContainer_1
    const modalContainer_1 = scene.add.container(0, 0);
    walkthroughPanel_9.add(modalContainer_1);

    // nineslice_2
    const nineslice_2 = scene.add.nineslice(
      0,
      204,
      'Hud3',
      undefined,
      92,
      36,
      16,
      16,
      16,
      16,
    );
    nineslice_2.scaleX = 4;
    nineslice_2.scaleY = 4;
    modalContainer_1.add(nineslice_2);

    // riposteTypingView_1
    const riposteTypingView_1 = scene.add.container(0, -56);
    modalContainer_1.add(riposteTypingView_1);

    // typingBacking_1
    const typingBacking_1 = scene.add.image(7, 82, 'Card-512');
    typingBacking_1.scaleX = 2;
    typingBacking_1.scaleY = 2;
    riposteTypingView_1.add(typingBacking_1);

    // bitmaptext
    const bitmaptext = scene.add.bitmapText(0, 82, 'Aronui', 'Tap');
    bitmaptext.setOrigin(0.5, 0.5);
    bitmaptext.tintTopLeft = 6896829;
    bitmaptext.tintTopRight = 6896829;
    bitmaptext.tintBottomLeft = 6896829;
    bitmaptext.tintBottomRight = 6896829;
    bitmaptext.text = 'Tap';
    bitmaptext.fontSize = -64;
    riposteTypingView_1.add(bitmaptext);

    // cursor_1
    const cursor_1 = new Cursor(scene, 66, 82);
    riposteTypingView_1.add(cursor_1);

    // buttons_1
    const buttons_1 = scene.add.container(0, 232);
    buttons_1.scaleX = 2;
    buttons_1.scaleY = 2;
    modalContainer_1.add(buttons_1);

    // image_3
    const image_3 = scene.add.image(0, 0, 'ui-definition-button');
    image_3.scaleX = 2;
    image_3.scaleY = 2;
    buttons_1.add(image_3);

    // image_4
    const image_4 = scene.add.image(-36, 0, 'ui-repeat-button');
    image_4.scaleX = 2;
    image_4.scaleY = 2;
    buttons_1.add(image_4);

    // image_5
    const image_5 = scene.add.image(36, 0, 'ui-speak-button');
    image_5.scaleX = 2;
    image_5.scaleY = 2;
    buttons_1.add(image_5);

    // riposteHeader_1
    const riposteHeader_1 = scene.add.container(0, -280);
    modalContainer_1.add(riposteHeader_1);

    // riposteHeaderBacking_1
    const riposteHeaderBacking_1 = scene.add.nineslice(
      0,
      0,
      'Hud2',
      undefined,
      100,
      16,
      8,
      8,
      8,
      8,
    );
    riposteHeaderBacking_1.scaleX = 4;
    riposteHeaderBacking_1.scaleY = 4;
    riposteHeader_1.add(riposteHeaderBacking_1);

    // riposteHeaderText_1
    const riposteHeaderText_1 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Perform Counter',
    );
    riposteHeaderText_1.setOrigin(0.5, 0.5);
    riposteHeaderText_1.tintTopLeft = 985612;
    riposteHeaderText_1.tintTopRight = 985612;
    riposteHeaderText_1.tintBottomLeft = 985612;
    riposteHeaderText_1.tintBottomRight = 985612;
    riposteHeaderText_1.text = 'Perform Counter';
    riposteHeaderText_1.fontSize = -24;
    riposteHeader_1.add(riposteHeaderText_1);

    // buttonBacking_3
    const buttonBacking_3 = scene.add.image(0, 168, 'default-button-confirm');
    buttonBacking_3.scaleX = 2;
    buttonBacking_3.scaleY = 2;
    modalContainer_1.add(buttonBacking_3);

    // buttonLabel_3
    const buttonLabel_3 = scene.add.bitmapText(0, 168, 'Aronui', 'Submit');
    buttonLabel_3.setOrigin(0.5, 0.5);
    buttonLabel_3.tintTopLeft = 15130076;
    buttonLabel_3.tintTopRight = 15130076;
    buttonLabel_3.tintBottomLeft = 15130076;
    buttonLabel_3.tintBottomRight = 15130076;
    buttonLabel_3.text = 'Submit';
    buttonLabel_3.fontSize = -14;
    modalContainer_1.add(buttonLabel_3);

    // interactiveOverlay
    const interactiveOverlay = scene.add.image(0, 0, '1x1sprite');
    interactiveOverlay.scaleX = 1024;
    interactiveOverlay.scaleY = 768;
    interactiveOverlay.setOrigin(0, 0);
    interactiveOverlay.alpha = 0.001;
    interactiveOverlay.alphaTopLeft = 0.001;
    interactiveOverlay.alphaTopRight = 0.001;
    interactiveOverlay.alphaBottomLeft = 0.001;
    interactiveOverlay.alphaBottomRight = 0.001;
    this.add(interactiveOverlay);

    // continueButtonContainer
    const continueButtonContainer = scene.add.container(1024, 768);
    this.add(continueButtonContainer);

    // continueButton
    const continueButton = new DefaultButton(scene, -120, -48);
    continueButtonContainer.add(continueButton);

    // continueButtonContainer_m
    const continueButtonContainer_m = scene.add.container(1024, 768);
    this.add(continueButtonContainer_m);

    // continueButton_m
    const continueButton_m = new DefaultConfirmButton_m(scene, -120, -48);
    continueButtonContainer_m.add(continueButton_m);

    // boardOverlays
    const boardOverlays = scene.add.container(512, 768);
    this.add(boardOverlays);

    // walkthroughPanelStart
    const walkthroughPanelStart = scene.add.container(-512, -768);
    boardOverlays.add(walkthroughPanelStart);

    // walkthroughPanel
    const walkthroughPanel = scene.add.container(0, 0);
    boardOverlays.add(walkthroughPanel);

    // labelContainer
    const labelContainer = scene.add.container(120, -396);
    walkthroughPanel.add(labelContainer);

    // textBacking
    const textBacking = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      50,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking.scaleX = 4;
    textBacking.scaleY = 32;
    textBacking.setOrigin(0.5, 0);
    textBacking.alpha = 0.5;
    textBacking.tint = 3023407;
    labelContainer.add(textBacking);

    // walkthroughLabel
    const walkthroughLabel = scene.add.bitmapText(0, 0, 'Aronui', 'Make Word');
    walkthroughLabel.setOrigin(0.5, 0);
    walkthroughLabel.tintTopLeft = 15130076;
    walkthroughLabel.tintTopRight = 15130076;
    walkthroughLabel.tintBottomLeft = 15130076;
    walkthroughLabel.tintBottomRight = 15130076;
    walkthroughLabel.text = 'Make Word';
    walkthroughLabel.fontSize = -28;
    labelContainer.add(walkthroughLabel);

    // guidanceArrow_1
    const guidanceArrow_1 = scene.add.image(0, -376, 'GuidanceArrow-Small');
    guidanceArrow_1.scaleX = 4;
    guidanceArrow_1.scaleY = 4;
    guidanceArrow_1.flipY = true;
    walkthroughPanel.add(guidanceArrow_1);

    // walkthroughPanel_1
    const walkthroughPanel_1 = scene.add.container(0, 0);
    boardOverlays.add(walkthroughPanel_1);

    // labelContainer_1
    const labelContainer_1 = scene.add.container(260, -138);
    walkthroughPanel_1.add(labelContainer_1);

    // textBacking_1
    const textBacking_1 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      52,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_1.scaleX = 4;
    textBacking_1.scaleY = 32;
    textBacking_1.setOrigin(0.5, 0);
    textBacking_1.alpha = 0.5;
    textBacking_1.tint = 3023407;
    labelContainer_1.add(textBacking_1);

    // walkthroughLabel_1
    const walkthroughLabel_1 = scene.add.bitmapText(
      0,
      -2,
      'Aronui',
      'Submit Word',
    );
    walkthroughLabel_1.setOrigin(0.5, 0);
    walkthroughLabel_1.tintTopLeft = 15130076;
    walkthroughLabel_1.tintTopRight = 15130076;
    walkthroughLabel_1.tintBottomLeft = 15130076;
    walkthroughLabel_1.tintBottomRight = 15130076;
    walkthroughLabel_1.text = 'Submit Word';
    walkthroughLabel_1.fontSize = -28;
    labelContainer_1.add(walkthroughLabel_1);

    // guidanceArrow
    const guidanceArrow = scene.add.image(136, -120, 'GuidanceArrow-Small');
    guidanceArrow.scaleX = 4;
    guidanceArrow.scaleY = 4;
    guidanceArrow.angle = -90;
    walkthroughPanel_1.add(guidanceArrow);

    // buttonBacking_1
    const buttonBacking_1 = scene.add.image(0, -120, 'default-button-confirm');
    buttonBacking_1.scaleX = 2;
    buttonBacking_1.scaleY = 2;
    walkthroughPanel_1.add(buttonBacking_1);

    // buttonLabel_1
    const buttonLabel_1 = scene.add.bitmapText(0, -120, 'Aronui', 'Submit');
    buttonLabel_1.setOrigin(0.5, 0.5);
    buttonLabel_1.tintTopLeft = 15130076;
    buttonLabel_1.tintTopRight = 15130076;
    buttonLabel_1.tintBottomLeft = 15130076;
    buttonLabel_1.tintBottomRight = 15130076;
    buttonLabel_1.text = 'Submit';
    buttonLabel_1.fontSize = -14;
    walkthroughPanel_1.add(buttonLabel_1);

    // walkthroughPanel_2
    const walkthroughPanel_2 = scene.add.container(0, 0);
    boardOverlays.add(walkthroughPanel_2);

    // labelContainer_2
    const labelContainer_2 = scene.add.container(76, -192);
    walkthroughPanel_2.add(labelContainer_2);

    // textBacking_2
    const textBacking_2 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      52,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_2.scaleX = 4;
    textBacking_2.scaleY = 32;
    textBacking_2.setOrigin(0.5, 0);
    textBacking_2.alpha = 0.5;
    textBacking_2.tint = 3023407;
    labelContainer_2.add(textBacking_2);

    // walkthroughLabel_2
    const walkthroughLabel_2 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Repeat Word',
    );
    walkthroughLabel_2.setOrigin(0.5, 0);
    walkthroughLabel_2.tintTopLeft = 15130076;
    walkthroughLabel_2.tintTopRight = 15130076;
    walkthroughLabel_2.tintBottomLeft = 15130076;
    walkthroughLabel_2.tintBottomRight = 15130076;
    walkthroughLabel_2.text = 'Repeat Word';
    walkthroughLabel_2.fontSize = -28;
    labelContainer_2.add(walkthroughLabel_2);

    // audioButton_8
    const audioButton_8 = scene.add.image(76, -56, 'ui-repeat-button');
    audioButton_8.scaleX = 4;
    audioButton_8.scaleY = 4;
    walkthroughPanel_2.add(audioButton_8);

    // guidanceArrow_9
    const guidanceArrow_9 = scene.add.image(76, -128, 'GuidanceArrow-Small');
    guidanceArrow_9.scaleX = 4;
    guidanceArrow_9.scaleY = 4;
    guidanceArrow_9.flipY = true;
    walkthroughPanel_2.add(guidanceArrow_9);

    // walkthroughPanel_3
    const walkthroughPanel_3 = scene.add.container(0, 0);
    boardOverlays.add(walkthroughPanel_3);

    // labelContainer_3
    const labelContainer_3 = scene.add.container(4, -192);
    walkthroughPanel_3.add(labelContainer_3);

    // textBacking_3
    const textBacking_3 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      56,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_3.scaleX = 4;
    textBacking_3.scaleY = 32;
    textBacking_3.setOrigin(0.5, 0);
    textBacking_3.alpha = 0.5;
    textBacking_3.tint = 3023407;
    labelContainer_3.add(textBacking_3);

    // walkthroughLabel_3
    const walkthroughLabel_3 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Hear Definition',
    );
    walkthroughLabel_3.setOrigin(0.5, 0);
    walkthroughLabel_3.tintTopLeft = 15130076;
    walkthroughLabel_3.tintTopRight = 15130076;
    walkthroughLabel_3.tintBottomLeft = 15130076;
    walkthroughLabel_3.tintBottomRight = 15130076;
    walkthroughLabel_3.text = 'Hear Definition';
    walkthroughLabel_3.fontSize = -28;
    labelContainer_3.add(walkthroughLabel_3);

    // audioButton_7
    const audioButton_7 = scene.add.image(4, -56, 'ui-definition-button');
    audioButton_7.scaleX = 4;
    audioButton_7.scaleY = 4;
    walkthroughPanel_3.add(audioButton_7);

    // guidanceArrow_8
    const guidanceArrow_8 = scene.add.image(4, -128, 'GuidanceArrow-Small');
    guidanceArrow_8.scaleX = 4;
    guidanceArrow_8.scaleY = 4;
    guidanceArrow_8.flipY = true;
    walkthroughPanel_3.add(guidanceArrow_8);

    // walkthroughPanel_4
    const walkthroughPanel_4 = scene.add.container(0, 0);
    boardOverlays.add(walkthroughPanel_4);

    // labelContainer_4
    const labelContainer_4 = scene.add.container(-76, -192);
    walkthroughPanel_4.add(labelContainer_4);

    // textBacking_4
    const textBacking_4 = scene.add.nineslice(
      0,
      2,
      'fadeOut2',
      undefined,
      92,
      0,
      3,
      3,
      0,
      0,
    );
    textBacking_4.scaleX = 4;
    textBacking_4.scaleY = 32;
    textBacking_4.setOrigin(0.5, 0);
    textBacking_4.alpha = 0.5;
    textBacking_4.tint = 3023407;
    labelContainer_4.add(textBacking_4);

    // walkthroughLabel_4
    const walkthroughLabel_4 = scene.add.bitmapText(
      0,
      0,
      'Aronui',
      'Hear Word in Sentence',
    );
    walkthroughLabel_4.setOrigin(0.5, 0);
    walkthroughLabel_4.tintTopLeft = 15130076;
    walkthroughLabel_4.tintTopRight = 15130076;
    walkthroughLabel_4.tintBottomLeft = 15130076;
    walkthroughLabel_4.tintBottomRight = 15130076;
    walkthroughLabel_4.text = 'Hear Word in Sentence';
    walkthroughLabel_4.fontSize = -28;
    labelContainer_4.add(walkthroughLabel_4);

    // audioButton_6
    const audioButton_6 = scene.add.image(-68, -56, 'ui-speak-button');
    audioButton_6.scaleX = 4;
    audioButton_6.scaleY = 4;
    walkthroughPanel_4.add(audioButton_6);

    // guidanceArrow_7
    const guidanceArrow_7 = scene.add.image(-76, -128, 'GuidanceArrow-Small');
    guidanceArrow_7.scaleX = 4;
    guidanceArrow_7.scaleY = 4;
    guidanceArrow_7.flipY = true;
    walkthroughPanel_4.add(guidanceArrow_7);

    // continueButton (prefab fields)
    continueButton.buttonText = 'Next';

    // continueButton_m (prefab fields)
    continueButton_m.buttonText = 'Next';

    this.greenleaf_m = greenleaf_m;
    this.greenleafMobile = greenleafMobile;
    this.greenleaf = greenleaf;
    this.greenleafDesktop = greenleafDesktop;
    this.walkthroughPanel_6 = walkthroughPanel_6;
    this.healthBarRightOverlay = healthBarRightOverlay;
    this.walkthroughPanel_5 = walkthroughPanel_5;
    this.healthBarLeftOverlay = healthBarLeftOverlay;
    this.walkthroughPanel_11 = walkthroughPanel_11;
    this.walkthroughPanel_10 = walkthroughPanel_10;
    this.topRightOverlay = topRightOverlay;
    this.walkthroughPanel_7 = walkthroughPanel_7;
    this.topCenterOverlay = topCenterOverlay;
    this.walkthroughPanel_8 = walkthroughPanel_8;
    this.walkthroughPanel_9 = walkthroughPanel_9;
    this.ripostesOverlay = ripostesOverlay;
    this.interactiveOverlay = interactiveOverlay;
    this.continueButton = continueButton;
    this.continueButtonContainer = continueButtonContainer;
    this.continueButton_m = continueButton_m;
    this.continueButtonContainer_m = continueButtonContainer_m;
    this.walkthroughPanelStart = walkthroughPanelStart;
    this.walkthroughPanel = walkthroughPanel;
    this.walkthroughPanel_1 = walkthroughPanel_1;
    this.walkthroughPanel_2 = walkthroughPanel_2;
    this.walkthroughPanel_3 = walkthroughPanel_3;
    this.walkthroughPanel_4 = walkthroughPanel_4;
    this.boardOverlays = boardOverlays;

    /* START-USER-CTR-CODE */
    const walkthroughPanels = [
      this.walkthroughPanelStart,
      this.walkthroughPanel,
      this.walkthroughPanel_1,
      this.walkthroughPanel_2,
      this.walkthroughPanel_3,
      this.walkthroughPanel_4,
      this.walkthroughPanel_5,
      this.walkthroughPanel_6,
      this.walkthroughPanel_7,
      this.walkthroughPanel_8,
      this.walkthroughPanel_9,
      this.walkthroughPanel_10,
      this.walkthroughPanel_11,
    ];

    // Load audio.
    for (var i = 0; i < walkthroughPanels.length; i++) {
      this.scene.load.audio(
        `walkthrough-duel-${i}`,
        `game_assets/audio/mentors/walkthroughs/walkthrough-duel-${i}.mp3`,
      );
    }
    this.scene.load.start();

    const audioKeys: string[] = [];
    for (var j = 0; j < walkthroughPanels.length; j++) {
      audioKeys.push(`walkthrough-duel-${j}`);
    }

    const student = getStudent();
    this.scene.load.on('complete', async () => {
      // Responsiveness.
      this.initializeResponsiveness();

      this.walkthroughController = new WalkthroughController({
        parent: this,
        audioKeys,
        slides: walkthroughPanels,
        continueButton: this.continueButton,
        continueButton_m: this.continueButton_m,
        responsiveOverlay: this.interactiveOverlay,
      });
      if (!student.tutorialization.hasViewedDuelWalkthrough) {
        await waitForSeconds(this.scene.time, 2.2);
        this.walkthroughController?.initialize();
      }
    });

    // Button callbacks.
    this.continueButton.controller.setSubmissionCallback(() => {
      this.walkthroughController?.progressWalkthrough();
    });

    /* END-USER-CTR-CODE */
  }

  private greenleaf_m: Phaser.GameObjects.Image;
  public greenleafMobile: Phaser.GameObjects.Container;
  private greenleaf: Phaser.GameObjects.Image;
  public greenleafDesktop: Phaser.GameObjects.Container;
  private walkthroughPanel_6: Phaser.GameObjects.Container;
  private healthBarRightOverlay: Phaser.GameObjects.Container;
  private walkthroughPanel_5: Phaser.GameObjects.Container;
  private healthBarLeftOverlay: Phaser.GameObjects.Container;
  private walkthroughPanel_11: Phaser.GameObjects.Container;
  private walkthroughPanel_10: Phaser.GameObjects.Container;
  private topRightOverlay: Phaser.GameObjects.Container;
  private walkthroughPanel_7: Phaser.GameObjects.Container;
  private topCenterOverlay: Phaser.GameObjects.Container;
  private walkthroughPanel_8: Phaser.GameObjects.Container;
  private walkthroughPanel_9: Phaser.GameObjects.Container;
  private ripostesOverlay: Phaser.GameObjects.Container;
  private interactiveOverlay: Phaser.GameObjects.Image;
  public continueButton: DefaultButton;
  private continueButtonContainer: Phaser.GameObjects.Container;
  public continueButton_m: DefaultConfirmButton_m;
  private continueButtonContainer_m: Phaser.GameObjects.Container;
  private walkthroughPanelStart: Phaser.GameObjects.Container;
  private walkthroughPanel: Phaser.GameObjects.Container;
  private walkthroughPanel_1: Phaser.GameObjects.Container;
  private walkthroughPanel_2: Phaser.GameObjects.Container;
  private walkthroughPanel_3: Phaser.GameObjects.Container;
  private walkthroughPanel_4: Phaser.GameObjects.Container;
  private boardOverlays: Phaser.GameObjects.Container;

  /* START-USER-CODE */
  private walkthroughController?: WalkthroughController;

  awake() {
    this.walkthroughController?.initialize();
  }

  reset() {
    this.walkthroughController?.reset();
  }

  initializeResponsiveness() {
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.greenleafDesktop,
      mobileView: this.greenleafMobile,
    });

    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.continueButtonContainer,
      mobileView: this.continueButtonContainer_m,
    });

    const anchor = getAnchorPlugin(this.scene);

    anchor.add(this.healthBarLeftOverlay, {
      left: '0%',
      top: '0%',
    });

    anchor.add(this.healthBarRightOverlay, {
      right: '100%',
      top: '0%',
    });

    anchor.add(this.topRightOverlay, {
      right: '100%',
    });
    anchor.add(this.greenleaf, {
      right: '90%',
      bottom: '100%+100',
    });
    anchor.add(this.interactiveOverlay, {
      width: '100%',
      height: '100%',
      left: '0%',
      top: '0%',
    });
    anchor.add(this.topCenterOverlay, {
      centerX: '50%',
    });
    anchor.add(this.continueButtonContainer, {
      bottom: '100%',
      right: '100%',
    });
    anchor.add(this.continueButtonContainer_m, {
      bottom: '100%',
      right: '100%',
    });
    anchor.add(this.ripostesOverlay, {
      centerX: '50%',
      centerY: '50%',
    });

    ResponsivenessManager.MakeElementsScaleDownWithGameSize(
      [
        this.boardOverlays,
        this.healthBarLeftOverlay,
        this.healthBarRightOverlay,
        this.topRightOverlay,
        this.topCenterOverlay,
        this.ripostesOverlay,
      ],
      DEFAULT_SCALE_DOWN_CONFIG,
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.greenleaf, {
      ...DEFAULT_SCALE_DOWN_CONFIG,
      scaleModifier: 0.4,
    });

    ResponsivenessManager.InitializeResizeHandler(
      this.scene,
      () => this.handleResize(),
      this,
    );

    this.handleResize();
  }

  async handleResize() {
    if (!this.scene || !this.scene.scene.isActive()) return;
    await waitForMilliseconds(this.scene.time, 1);
    const breakpoint = ResponsivenessManager.GetCurrentGlobalViewForGame(
      this.scene,
    );
    const anchor = getAnchorPlugin(this.scene);
    if (breakpoint === 'mobile') {
      anchor.add(this.boardOverlays, {
        bottom: '100%',
        centerX: '50%',
      });
    } else {
      anchor.add(this.boardOverlays, {
        bottom: '100%-32',
        centerX: '50%',
      });
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
